import React from "react";

import { microsoftTodoKey } from "~/settings/Integrations/MicrosoftTodo/MicrosoftTodoIntegration";

import { getIntegrationForKey, type renderPillArgument } from "../actionItemIntegration";
import { WidgetInner } from "../actionItemIntegration/Widget";

export const microsoftTodoSpecificDataNodeTypename = "MicrosoftTodoActionItemIntegrationSpecificDataNode";

export function MicrosoftTodoActionItemIntegrationLinkWidget({ actionItemLink, customClassName }: renderPillArgument) {
	if (actionItemLink.integrationData.__typename !== microsoftTodoSpecificDataNodeTypename) {
		throw new Error("Incorrect integration to render pill");
	}

	const microsoftTodoData = actionItemLink.integrationData;
	const { externalListName, externalTaskId } = microsoftTodoData;

	const updating = actionItemLink.syncStatus !== "DONE_SYNCING_EXTERNALLY";

	const url = `https://to-do.office.com/tasks/${externalTaskId}/details`;

	const tooltip = externalListName ?? undefined;

	const logo = getIntegrationForKey(microsoftTodoKey).logo;

	return (
		<WidgetInner tooltip={tooltip} logo={logo} updating={updating} url={url} customClassName={customClassName}>
			{externalListName}
		</WidgetInner>
	);
}
